<template>
  <div>
    <pcHeaders></pcHeaders>
    <div class="namms">
      <div>
        <div class="suc">
          <div><img src="../../assets/images/pay_03.png"
                 alt="铜仁学院省级专业技术人员继续教育培训平台"></div>
          <div style="font-size: 22px;color: #ff9f53;margin-top: 22px;">恭喜您，支付成功</div>
        </div>

        <div class="payDetail">
          <div class="payHead">
            <div class="su"></div>
            <div style="font-weight: bold;">支付详情</div>
          </div>
          <div class="list">
            <div>运单编号</div>
            <div>{{ orderList.expressNo }}</div>
          </div>
          <div class="list">
            <div>支付时间</div>
            <div>{{ orderList.expressPaytime }}</div>
          </div>
          <div class="list">
            <div>支付方式</div>
            <div>
              {{ orderList.expressPaytype =='W01' ? '微信扫码支付' :  
              orderList.expressPaytype =='W02' ? '微信Js支付' 
              :orderList.expressPaytype =='A01' ? '支付宝扫码支付' 
              :orderList.expressPaytype =='A02' ? '支付宝Js支付'
              :''}}
            </div>
          </div>
          <div class="list">
            <div>支付金额</div>
            <div style="color: #ff9f53;">￥{{ orderList.expressPrice }}</div>
          </div>
        </div>
      </div>
    </div>
    <pcBottom></pcBottom>
  </div>
</template>
<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import pcHeaders from '../component/head.vue';
import pcBottom from '../component/bottom.vue';
import { getExpressDetail } from '@/api/cert.js';

export default {
  // import引入的组件需要注入到对象中才能使用
  components: {
    pcHeaders,
    pcBottom
  },
  data() {
    // 这里存放数据
    return {
      orderList: {},
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    goStudy() {
      this.$router.push('/studyMain')
    },
    getList() {
      getExpressDetail({ expressId: this.$route.query.orderId }).then(res => {
        this.orderList = res.data.data
      });
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getList();
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {} // 生命周期 - 挂载之前
};
</script>
<style lang="less" scoped>
/* //@import url(); 引入公共css类 */
.namms {
  display: flex;
  justify-content: center;
  padding: 30px;

  .suc {
    width: 1400px;
    height: 198px;
    border: 1px solid #ebebeb;
    box-shadow: 0 0 6px #ccc;
    margin-top: 22px;
    text-align: center;
    padding-top: 45px;
  }

  .payDetail {
    width: 1400px;
    margin-top: 16px;
    .payHead {
      padding: 0 45px;
      display: flex;
      align-items: center;
      font-size: 18px;
      color: #666;
      height: 54px;
      border-top: 1px solid #d0d0d0;
      border-left: 1px solid #d0d0d0;
      border-right: 1px solid #d0d0d0;
      .su {
        width: 5px;
        height: 22px;
        border-radius: 4px;
        background: #ffa45b;
        vertical-align: middle;
        margin-right: 5px;
      }
    }
    .list {
      display: flex;
      justify-content: space-between;
      align-items: center;
      border: 1px dashed #d0d0d0;
      height: 40px;
      background: #f7f7f7;
      padding: 0 45px;
      font-size: 14px;
      color: #999999;
    }
    .tables {
      width: 100%;
      display: flex;
      justify-content: space-around;
      font-size: 16px;
      border: 1px solid #d0d0d0;
      border-top: 0;
      min-height: 60px;

      div {
        border-right: 1px solid #d0d0d0;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 25%;
      }
      div:nth-child(5) {
        border: 0 !important;
      }
      .sudyBtn {
        width: 50% !important;
        height: 25px;
        color: #ff9f53;
        border-radius: 3px;
        line-height: 25px;
        font-size: 14px;
        text-align: center;
        cursor: pointer;
        border: 0 !important;
      }
    }
  }
}
</style>